<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from '../icons.js';
  import { getLanguages, mapTargetLanguages } from '../Review-Request-Form/utils.js';
  import {mapMutations, mapState} from "vuex";
  import statusColors from '../Acclaro-Datatable/statusColors.js';
  
  import {
    AsStatus,
    AsInfo,
  } from '../Acclaro-Datatable/cells';
  
  import {
    PencilIcon,
    UploadIcon,
    AccountOffOutlineIcon,
    AccountOffIcon,
    BadgeAccountHorizontalIcon,
  } from '../icons.js';
  
  const INACTIVE_REVIEWER = 2;
  const ACTIVE_REVIEWER = 1;

  export default {

    props: {

      isPm: {
        type: Boolean,
        default: false
      },

      isAdmin: {
        type: Boolean,
        default: false
      }
    },

    beforeMount () {

      //check if the user already has reviewers data
      const checkReviewers = () => {
        let uri = this.isAdmin ? '/datatables/admin/reviewers' : '/datatables/reviewers';

        axios.get(uri, {
          params: {
            'nofilters': true
          }
        }).then(result => {
          let { data } = result.data;

          //@NOTE - make this false to do a full walkthrough
          if (data && data.length) {
            this.finishForm();
          }
          else {
            this.heroIsVisible = true;
          }
        })
      }

      checkReviewers();

      getLanguages().then(languages => this.languages = languages);
    },
  computed: {
    ...mapState('ReviewerImportFormStore', [
      'showImportForm'
    ]),
    
    datatableOptions () {  
      return {
        sortable: ['Name', 'Email', 'Last Sign-In', 'Status', 'Company'],
        perPage: 20,
        rowClassCallback: (row) => {
            if (row.hasOwnProperty('status') && (row.status === 'Pending')) {
                return 'pending-reviewer';
            }

            if (row.hasOwnProperty('status') && (row.status === 'Inactive')) {
                return 'pending-reviewer';
            }

            return '';
        },
      };
    },
    
    templates () {
      let $vm = this;
      
      return {
        Status: function (h, row, index) {
          const props = { row, column: 'Status' };
          return (
            <AsStatus props={props}>
              <span class={'status-dots status-' + $vm.getStatusColor(row.Status)}></span>
            </AsStatus>
          );
        },
        
        Notes: function (h, row, index) {
          const props = { row, column: 'Notes' };
          return (
            <AsInfo props={props} title="Notes">
              <BadgeAccountHorizontalIcon title="Reviewer Notes" fillColor="#333" size={18}  />
            </AsInfo>
          );
        },
        Email: function (h, row, index) {
            return  (row.email);
        },
        Name: function (h, row, index) {
            return (row.name);
        },
        'Last Sign-In': function (h, row, index) {
          const props = { row, column: 'Last Sign-In' };
          
          let $accountIcon = '';
          
          if (
            $vm.isPm
            && row.status !== 'Inactive'
            && row.is_reviewer == ACTIVE_REVIEWER
          ) {
            $accountIcon = (
              <div v-tooltip={'Deactivate Reviewer'}>
                <AccountOffIcon
                  title="Deactivate Reviewer"
                  class="clickable"
                  onClick={() => $vm.confirmDeleteReviewer(props.row)}
                  size={18} />
              </div>
            );
          }
          
          if ($vm.isPm && row.is_reviewer == INACTIVE_REVIEWER) {
            $accountIcon = (
              <div v-tooltip={'Activate Reviewer'} >
                <AccountOffOutlineIcon
                  title="Activate Reviewer"
                  class="clickable"
                  onClick={() => $vm.activateReviewer(row)}
                  size={18}
                 />
              </div>
            );
          }
          
          return (
            <div>
              <div class="flex-data-row">
                <div>{row['Last Sign-In'] || '-'}</div>
                <div onClick={() => $vm.editReviewer(row)} v-tooltip="'Edit Reviewer'">
                  <PencilIcon title="Edit Reviewer" class="clickable" size={18} />
                </div>
                {$accountIcon}
              </div>
            </div>
          );
        },
      };
    }
  },
  methods: {
    ...mapMutations('ReviewerImportFormStore', [
      'toggleShowForm',
    ]),
    
    getStatusColor (status) {
      return statusColors[status.toLowerCase()];
    },
    
    toggleForm (state) {
      let {isVisible} = state;

      this.formIsVisible = isVisible;

      if (!this.formIsVisible) {
        this.toggleEditMode(null, false);
      }
    },
    toggleImportReviewersForm (state) {

      this.toggleShowForm(true);

    },

    toggleEditMode (reviewer, isActive) {
      this.editableReviewer = reviewer;
      this.formEditMode = isActive;
    },

    finishForm () {
      if (this.tableIsVisible) this.refreshTable();

      this.tableIsVisible = true;
        this.heroIsVisible = false;
        this.toggleEditMode(null, false)
      },

    refreshTable () {
        this.$refs.searchView.refreshTable();
      },

    editReviewer (reviewer) {
        this.toggleEditMode(reviewer, true)

      this.toggleForm({isVisible: true});
      },

    reviewerUpdated () {
        this.finishForm();
        this.toggleForm({isVisible: false});
      },

    deleteReviewer (reviewer) {
        //@NOTE - remove undo functionality?
        /*let {email: r_mail, name, languages, id, notes} = reviewer;

        let target_languages = mapTargetLanguages(languages || '', this.languages);

        name = name.split(' ');

        let userObj = {
          first_name: name[0],
          last_name: name[1],
          r_mail,
          notes,
          target_languages,
        }*/

      axios.delete(`/review/reviewer/${reviewer.id}`).then(result => {
          this.refreshTable();

        //this.deletedReviewer = userObj;
        })
      },
      
      activateReviewer (reviewer) {
        this.$modal.show('dialog', {
          title: `Enable ${reviewer.Name}`,
          text: `${reviewer.Name} was enabled as a reviewer.`,
          buttons: [
            {
              title: 'Close',
              class: 'vue-dialog-button reviewer-dialog-btn close-btn',
              handler: () => {
                this.$modal.hide('dialog');
              }
            },
          ]
        });
        //TODO enable with disable is implemented
        //https://github.com/AcclaroInc/acclaro-webapp/issues/4115
        
        axios.patch(`/review/reviewer/${reviewer.id}/activate`, { reviewer })
          .then(result => {
            this.refreshTable();
          });
      },

    undoDeleteReviewer () {
        axios.post('/review/reviewers', {
          reviewers: [this.deletedReviewer]
        }).then(result => {
          this.deletedReviewer = {};
          this.refreshTable()
        });
      },

      removeDeletedReviewer () {
        this.deletedReviewer = {};
      },
      
      confirmDeleteReviewer (reviewer) {
        this.$modal.show('dialog', {
          title: `Deactivate ${reviewer.Name}`,
          text: `Deactivated reviewers will no longer have access
          to their review assignments.  The reviewer you are
          about to deactivate may have review tasks assigned that have
          not been completed yet.  Are you sure you want to
          deactivate this reviewer?`,
          buttons: [
            {
              title: 'Cancel',
              class: 'vue-dialog-button reviewer-dialog-btn close-btn',
              handler: () => {
                this.$modal.hide('dialog')
              }
            },
            {
              title: 'Deactivate Reviewer',
              class: 'vue-dialog-button reviewer-dialog-btn edit-btn',
              handler: () => {
                this.deleteReviewer(reviewer);
                this.$modal.hide('dialog')
              }
            }
          ]
        });
      },
    },

    template,

    data () {

      return {
        isActive: false,

        formIsVisible: false,

        tableIsVisible: false,

        heroIsVisible: false,

        editableReviewer: {},

        deletedReviewer: {},

        formEditMode: false,

        reviewersUrl: this.isAdmin ? '/datatables/admin/reviewers' : '/datatables/reviewers',

        languages: [],
      }
    },

  components: {
      ChevronDownIcon,
      ChevronUpIcon,
      CloseIcon,
      UploadIcon
    }
  };
</script>
